import * as React from 'react';

// Components
import LimitLeft from './components/limit-left';
import LimitReached from './components/limit-reached';

// Constants
import { LIMIT_TYPE } from '../../constants';

const DSAgreementRuptlyPass = ({ agreement }) => {
  const { limit_type } = agreement.can_download_content || {};
  const Component = limit_type === LIMIT_TYPE.NONE ? LimitLeft : LimitReached;

  return <Component agreement={agreement} />;
};

export default DSAgreementRuptlyPass;
